import { Record as record } from 'immutable';
import moment from 'moment';
import { some, padStart } from 'lodash';

import { construct, fields } from '../helpers/LinkMapper';
import { DurationPeriods } from '../constants/AppConstants';

class ValidityPeriod extends record({ days: 0, months: 0}) {

    static fromJSON (json = {}) {
        return construct(ValidityPeriod, json, {
            days: fields.number,
            months: fields.number
        });
    }

    static fromString (string) {
        if (!string || string.length !== 4) {
            return new ValidityPeriod();
        }

        return ValidityPeriod.fromJSON({
            days: string.substring(2, 4),
            months: string.substring(0, 2)
        });
    }

    toString () {
        const pad = (value) => padStart(value, 2, '0');
        return `${pad(this.months)}${pad(this.days)}`;
    }

    toDuration () {
        return moment.duration({
            months: this.months,
            days: this.days
        });
    }

    toISOString () {
        let string = 'P';
        if (this.months) {
            string += `${this.months}M`;
        }

        if (this.days) {
            string += `${this.days}D`;
        }

        return string;
    }

    equals (period) {
        return this.days === period.days && this.months === period.months;
    }

    matchDurationType (type) {
        const [ months, days ] = DurationPeriods[type];
        return this.months === months && this.days === days;
    }

    isCustom () {
        return !some(Object.keys(DurationPeriods), this.matchDurationType.bind(this));
    }
}

export default ValidityPeriod;
